<template>
    <b-card no-body class="shadow rounded">
        <b-card-body class="p-3">
            <div class="d-flex h-100 align-items-top">
                <b-form-group
                    label="Enter your secret santa code"
                    label-for="code"
                    class="mx-auto mt-3">
                    <b-input-group>
                        <b-form-input id="code" v-model="code" v-on:keyup.enter="submit"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="danger" v-on:click="submit">
                                <font-awesome-icon icon="candy-cane" />
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    data: () => {
        return { code: null }
    },
    methods: {
        submit() {
            this.$store.commit('participants/setCode', code.value);
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
